(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@react-native-async-storage/async-storage"));
	else if(typeof define === 'function' && define.amd)
		define(["@react-native-async-storage/async-storage"], factory);
	else if(typeof exports === 'object')
		exports["FansUnitedSDK"] = factory(require("@react-native-async-storage/async-storage"));
	else
		root["FansUnitedSDK"] = factory(root["@react-native-async-storage/async-storage"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__76878__) => {
return 